<script setup>
import AOS from 'aos';
import FunctionalitiesHeader from '@/components/functionalities/FunctionalitiesHeader.vue';
import FunctionalitiesAppointment from '@/components/functionalities/blocks/FunctionalitiesAppointment.vue';
import FunctionalitiesReceptions from '@/components/functionalities/blocks/FunctionalitiesReceptions.vue';
import FunctionalitiesRepair from '@/components/functionalities/blocks/FunctionalitiesRepair.vue'
import FunctionalitiesPlanning from '@/components/functionalities/blocks/FunctionalitiesPlanning.vue'
import FunctionalitiesInvoice from '@/components/functionalities/blocks/FunctionalitiesInvoice.vue'
import FunctionalitiesCustomer from '@/components/functionalities/blocks/FunctionalitiesCustomer.vue'
import FunctionalitiesCar from '@/components/functionalities/blocks/FunctionalitiesCar.vue'
import FunctionalitiesGdpr from '@/components/functionalities/blocks/FunctionalitiesGdpr.vue'

AOS.init({
    duration: 2000,
    once: false
})

</script>

<template>
    <div class="w-100 custom-inner-view container-functionality-wrapper">
        <FunctionalitiesHeader />
        <div class="functionalitites-blocks container" >
            <div class="" data-aos="fade-up">
                <FunctionalitiesAppointment />
            </div>
            <div class="" data-aos="fade-up">
                <FunctionalitiesReceptions />
            </div>
            <div class="" data-aos="fade-up">
                <FunctionalitiesRepair />
            </div>
            <div class="" data-aos="fade-up">
                <FunctionalitiesPlanning />
            </div>
            <div class="" data-aos="fade-up">
                <FunctionalitiesInvoice />
            </div>
            <div class="" data-aos="fade-up">
                <FunctionalitiesCustomer />
            </div>
            <div class="" data-aos="fade-up">
                <FunctionalitiesGdpr />
            </div>
            <div class="" data-aos="fade-up">
                <FunctionalitiesCar />
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .container-functionality-wrapper {
        padding-left: 150px;
        padding-right: 150px;
        .functionalitites-blocks {
            padding: 120px 130px 100px 130px;
        }
    }
    @media (max-width: 1400px) {
        .container-functionality-wrapper {
            padding-left: 50px;
            padding-right: 50px;
            .functionalitites-blocks {
                padding: 120px 10px 100px 10px;
            }
        }
    }
    @media (max-width: 1100px) {
        .container-functionality-wrapper {
            padding-left: 50px;
            padding-right: 50px;
            .functionalitites-blocks {
                padding: 120px 10px 100px 10px;
            }
        }
    }
    @media (max-width: 1000px) {
        .container-functionality-wrapper {
            padding: 60px 50px;
            .functionalitites-blocks {
                padding: 10px;
            }
        }
    }
    @media (max-width: 500px) {
        .container-functionality-wrapper {
            padding: 60px 0px;
        }
    }
</style>